module.exports = __webpack_public_path__ + "static/media/BS.bb311b4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BS.svg
// module id = 2119
// module chunks = 7